import { useParams } from "react-router-dom";

import { canUsePermission } from "../../../lib/auth";
import { useCurrentAuthUser } from "../../auth";
import { QuoteBudgetEditorFeaturePage } from "..";

/** 核价预算编辑器页：取路由 budgetOrderId 后交给特性页驱动运行时. */
export function QuoteBudgetEditorPage({ budgetOrderId: sourceBudgetOrderId, returnTo }: { budgetOrderId?: string; returnTo?: string } = {}) {
  const { budgetOrderId: routeBudgetOrderId } = useParams<{ budgetOrderId: string }>();
  const budgetOrderId = sourceBudgetOrderId ?? routeBudgetOrderId;
  const currentUserQuery = useCurrentAuthUser();
  const canOperate = currentUserQuery.isSuccess
    && canUsePermission(currentUserQuery.data, "opportunity.quote_budget:create");
  const canCreateCustomerQuote = currentUserQuery.isSuccess
    && canUsePermission(currentUserQuery.data, "opportunity.customer_quote:create")
    && canUsePermission(currentUserQuery.data, "opportunity.customer_quote:access");
  if (!budgetOrderId) {
    return <div role="alert">缺少预算单标识</div>;
  }
  return (
    <QuoteBudgetEditorFeaturePage
      key={`${currentUserQuery.data?.id ?? "anonymous"}:${budgetOrderId}`}
      budgetOrderId={budgetOrderId}
      returnTo={returnTo}
      userId={currentUserQuery.data?.id ? String(currentUserQuery.data.id) : undefined}
      permissionsReady={currentUserQuery.isSuccess}
      canOperate={canOperate}
      canImportConfirmation={canOperate && ["opportunity.quote_budget:access", "fulfillment.order:access", "fulfillment.order:create", "fulfillment.order:update"].every(permission => canUsePermission(currentUserQuery.data, permission))}
      canCreateCustomerQuote={canCreateCustomerQuote}
      canViewCustomerQuote={currentUserQuery.isSuccess && canUsePermission(currentUserQuery.data, "opportunity.customer_quote:access")}
      canViewItinerary={currentUserQuery.isSuccess && canUsePermission(currentUserQuery.data, "opportunity.itinerary:access")}
      canEditItinerary={canOperate && canUsePermission(currentUserQuery.data, "opportunity.itinerary:access") && canUsePermission(currentUserQuery.data, "opportunity.itinerary_editor:access") && canUsePermission(currentUserQuery.data, "opportunity.itinerary:update")}
    />
  );
}
